import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KartiniOnboard from "../assets/images/onboarding.webp";
import Webcam from "react-webcam";
import bg from "../assets/images/bg-success.png";
import CheckImg from "../assets/images/check.png";
import CardSection from "../components/Card/CardSection";
import ModalLoading from "../components/ModalLoading";
import { ReactComponent as ExclamationIcon } from "../assets/icons/exclamation.svg";
import { ReactComponent as ChevronIcon } from "../assets/icons/chevron.svg";
import {
  dataURItoBlob,
  formatRupiah,
  HEADER,
  sheetNotify,
  toastNotify,
} from "../utils/Utils";
import _, { debounce } from "lodash";
import { requestAuthGet, requestAuthPost } from "../api/authInstance";
import { requestAssetPost } from "../api/assetInstance";
import withAuth from "../components/withAuth";
import InformationSheet from "../components/Sheet/InformationSheet";
import axios from "axios";
import { Camera } from "react-camera-pro";
import Button from "../components/Button/Button";
import ModalMechanism from "../components/ModalMechanism";
import { useAuth } from "../components/auth/authContext";
import { Helmet } from "react-helmet";
import {
  initializeThirdParty,
  updateMultipleVoucherClaims,
} from "../api/uvcInstance";
import { compressImage, uploadFileToAsset } from "../utils/fileProcessing";
import { requestAiGet, requestAiPost } from "../api/aiInstance";
import { checkVoucherLimit } from "../api/voucherInstance";
import { buildSingleTransactionPayload } from "../utils/transactionPayload";
import Container from "../components/Container/Container";
import { useTranslation } from "react-i18next";
import {
  getBookVoucherCount,
  getManualRedemptionPolicy,
} from "../utils/manualRedemption";

const ConfirmVoucher = () => {
  const { userData } = useAuth();
  const { t } = useTranslation();
  const [imageReceipt, setImageReceipt] = useState(null);
  const [aiReceiptResult, setAiReceiptResult] = useState(null);
  const webcamRef = useRef(null);
  const [purchaseAmount, setPurchaseAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isShowMechanism, setIsShowMechanism] = useState(false);
  const { state } = useLocation();
  const {
    detailVoucher,
    redemptionMethod,
    settings,
    multipleSkuId,
    manualUvc,
  } = state ?? {};
  const data = {
    voucher: detailVoucher?.uvc?.voucher,
    voucherId: detailVoucher?.uvc?.voucher?.id ?? detailVoucher?.id,
    voucherRules:
      detailVoucher.voucherRules ??
      (detailVoucher?.uvc?.voucher?.voucherRules?.length > 0 &&
        detailVoucher?.uvc?.voucher?.voucherRules[0]),
    voucherMethod:
      detailVoucher?.voucherMethod ??
      detailVoucher?.uvc?.voucher?.voucherMethod,
    uvc: detailVoucher?.uvc,
    project: detailVoucher?.uvc?.voucher?.project ?? detailVoucher?.project,
    sku: detailVoucher?.uvc?.skus ?? detailVoucher?.skus,
    skuSelected: multipleSkuId ?? null,
    startDate:
      detailVoucher?.uvc?.voucherDateStart ?? detailVoucher?.voucherDateStart,
    endDate:
      detailVoucher?.uvc?.voucherDateEnd ?? detailVoucher?.voucherDateEnd,
    retailer: detailVoucher?.uvc?.retailer ?? userData?.outlet?.retailer,
  };
  const projectSettings =
    settings ??
    data?.uvc?.voucher?.project?.settings ??
    detailVoucher.project?.settings;

  const {
    shouldShowPhoneNumber,
    requiresCustomerPhone,
    shouldCheckCustomerLimit: isCustomerLimitCheckEnabled,
  } = getManualRedemptionPolicy(projectSettings);
  const shouldCheckCustomerLimit =
    redemptionMethod === "MANUAL" && isCustomerLimitCheckEnabled;

  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [message, setMessage] = useState({
    message: "",
    type: "",
    isShow: false,
  });
  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });
  const [numberOfCameras, setNumberOfCameras] = useState(0);

  const [loadingState, setLoadingState] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isCheckingCustomerLimit, setIsCheckingCustomerLimit] =
    useState(false);

  const normalizePhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");

    if (!digits) {
      return "";
    }

    if (digits.startsWith("62")) {
      return digits;
    }

    if (digits.startsWith("0")) {
      return `62${digits.slice(1)}`;
    }

    return `62${digits}`;
  };

  const isValidPhoneNumber = (value) => /^62\d{8,13}$/.test(value);
  const shouldRequireValidPhone =
    redemptionMethod === "MANUAL" && step === 1 && requiresCustomerPhone;

  // Reset camera to not ready when not in capture step
  useEffect(() => {
    if (step !== 2) {
      setNumberOfCameras(0);
    }
  }, [step]);

  useEffect(() => {
    if (!projectSettings.dompet) return;
    if (projectSettings.dompet.integration?.url) {
      initializeThirdParty(projectSettings.dompet);
    }
  }, [projectSettings]);

  const SubmitReceipt = async (imageUrl) => {
    // Validate imageUrl before making the request
    if (!imageUrl || typeof imageUrl !== "string" || imageUrl.trim() === "") {
      throw new Error(
        "Invalid image URL: URL is required and must be a non-empty string",
      );
    }

    const MAX_RETRIES = 3;
    for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
      try {
        const { data } = await requestAuthPost(`receipt/check`, {
          url: imageUrl,
        });
        const receiptData = data?.data;
        // Validate that we got a valid response object, not empty
        if (!receiptData || Object.keys(receiptData).length === 0) {
          throw new Error("Empty receipt data received from API");
        }
        return receiptData;
      } catch (error) {
        const code = error.code || error.response?.status;

        if (code !== 500 || attempt === MAX_RETRIES) {
          throw error;
        }
        await new Promise((resolve) =>
          setTimeout(resolve, 1000 * Math.pow(2, attempt)),
        );
      }
    }
  };

  const FetchReceiptDetail = async (submissionId) => {
    const { data } = await requestAiGet(
      `/libera/v2/receipt/${submissionId}/info`,
      {},
    );
    return data?.data;
  };

  const HandleReceiptSuccess = (detail) => {
    setAiReceiptResult(detail);
    setLoadingState(null);
    setShowModalLoading(false);

    setStep((prev) => prev + 1);
    setNumberOfCameras(0);

    toastNotify(
      "Great! Your receipt has been successfully detected. Everything looks good, and you're all set!",
      "success",
    );
  };

  const HandleReceiptFailure = () => {
    setLoadingState(null);
    setShowModalLoading(false);
    sheetNotify(
      {
        title: "Oops..",
        detail: t("redeem.invalidReceiptPhoto"),
        buttonLabel: t("common.tryAgain"),
        buttonAction: () => {
          setImageReceipt(null);
          setSheetDetail((prev) => ({ ...prev, open: false }));
        },
        children: CaptureInstruction(),
      },
      setSheetDetail,
    );
  };

  const capture = async () => {
    setLoadingState(`${t("redeem.uploadingReceipt")}...`);
    setShowModalLoading(true);

    try {
      const imageSrc = await webcamRef.current.takePhoto();

      // Upload receipt image and validate URL
      const imageUrl = await UploadStruk(imageSrc);
      setImageReceipt(imageUrl);

      if (
        !projectSettings?.ai?.isEnable ||
        !projectSettings?.ai?.receipt?.isEnable
      ) {
        setLoadingState(null);
        setShowModalLoading(false);
        setNumberOfCameras(0);
        setStep(3);
        return;
      }

      // Submit receipt for AI processing with validation
      const receiptData = await SubmitReceipt(imageUrl);

      const confidenceThreshold =
        projectSettings?.ai?.receipt?.confidenceThreshold ?? 0.5;
      const isConfident =
        receiptData?.clear_receipt_confidence > confidenceThreshold;

      if (receiptData?.is_receipt && isConfident) {
        HandleReceiptSuccess(receiptData);
        // setLoadingState("Memvalidasi Receipt. Mohon Tunggu...");

        // try {
        //   const detail = await FetchReceiptDetail(receiptData.submission_id);
        //   if (detail) {
        //     HandleReceiptSuccess(detail);
        //   } else {
        //     HandleReceiptFailure();
        //   }
        // } catch (error) {
        //   console.error(error);
        //   setLoadingState(null);
        //   setShowModalLoading(false);
        // }
      } else {
        HandleReceiptFailure();
      }
    } catch (error) {
      console.error("Capture error:", error);
      setImageReceipt(null);
      setLoadingState(null);
      setShowModalLoading(false);

      // Provide specific error messages
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      toastNotify(errorMessage, "error");
    }
  };

  async function VoucherRedeem() {
    setShowModalLoading(true);

    try {
      let uvcIndex = 0;
      // Validate aiReceiptResult - exclude if empty
      const validAiReceiptResult =
        aiReceiptResult && Object.keys(aiReceiptResult).length > 0
          ? aiReceiptResult
          : null;

      const payload =
        redemptionMethod === "MANUAL"
          ? {
              redemptionMethod: redemptionMethod,
              fileImage: imageReceipt ?? null,
              aiReceiptResult: validAiReceiptResult,
              phone: phoneNumber,
              // uvc: manualUvc ?? null,
              voucher: detailVoucher.id,
              project: data?.project?.id,
              retailer: data?.retailer?.id,
              uvcs: multipleSkuId.flatMap((product) => {
                return Array.from({ length: product.quantity }, () => {
                  const uvcObject = manualUvc[uvcIndex++];
                  return {
                    sku: product.id,
                    uvc: uvcObject.uvc,
                  };
                });
              }),
              mechanism: detailVoucher?.mechanism,
              amount: discount > 0 ? discount : detailVoucher.amountValue,
            }
          : buildSingleTransactionPayload({
              redemptionMethod,
              uvc: data.uvc,
              fileImage: imageReceipt,
              aiReceiptResult: validAiReceiptResult,
              voucherMethod: data.voucherMethod,
              discount,
              amountValue: detailVoucher.amountValue,
              voucherId: data.uvc.voucher.id,
              projectId: data?.project?.id,
              retailerId: data?.retailer?.id,
            });
      await requestAuthPost(
        redemptionMethod === "MANUAL" ? "transaction/bulk" : "transaction",
        payload,
      ).then((res) => {
        if (res.error) {
          toastNotify(res.message[0], "error");
        } else {
          if (!_.isEmpty(res)) {
            setStep(4);
            setMessage({
              message: t("redeem.redeemSuccess"),
              type: "success",
              isShow: true,
            });
            toastNotify("Voucher successfully redeemed", "success");
            // third-party integration
            if (
              projectSettings.dompet &&
              projectSettings.dompet?.integration?.url
            ) {
              updateMultipleVoucherClaims([
                {
                  uvc: {
                    code: payload.uvc,
                    timestamp: new Date().toISOString(),
                  },
                },
              ])
                .then((res) => {
                  console.log(res);
                  setTimeout(() => {
                    navigate("/", { replace: true });
                  }, 5000);
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              setTimeout(() => {
                navigate("/", { replace: true });
              }, 5000);
            }
          }
        }
      });
    } finally {
      setShowModalLoading(false);
    }
  }

  async function getCalc(value) {
    setIsLoading(true);
    try {
      let res = await requestAuthGet(`voucher-rule/discounts`, {
        params: {
          retailer: data?.retailer?.id,
          voucher: data?.voucherId,
          amount: value,
        },
      });
      if (data.voucherRules?.minPurchase) {
        if (value >= data.voucherRules?.minPurchase) {
          setDiscount(res.data.data);
        } else {
          setDiscount(0);
        }
      } else {
        setDiscount(res.data.data);
      }
    } catch (error) {
      setDiscount(0);
      console.error(error);
    }
    setIsLoading(false);
  }

  const calculate = useCallback(debounce(getCalc, 500), []);

  const UploadStruk = async (imageSrc) => {
    // Base64-encoded image data
    const base64Image = imageSrc;

    // Convert Base64 to a Blob
    const blob = dataURItoBlob(base64Image);

    // Create a File object from the Blob
    let file = new File([blob], "image.jpg", { type: "image/jpeg" });

    // Create FormData and append the File
    // const formData = new FormData();
    // formData.append("file", file);

    file = await compressImage(file, 1); // Compress the image to 1MB max size

    const uploadedUrl = await uploadFileToAsset(file);

    // Validate that upload returned a valid URL
    if (
      !uploadedUrl ||
      typeof uploadedUrl !== "string" ||
      uploadedUrl.trim() === ""
    ) {
      throw new Error(
        "Failed to upload receipt image: Invalid URL returned from server",
      );
    }

    return uploadedUrl;
  };

  const BannerMessage = () => {
    return (
      <>
        <img src={bg} alt="" className="absolute top-0 -z-50 w-full" />
        <div className="pt-24">
          <div className="flex flex-col items-center justify-center gap-2">
            {message.type === "success" && <img src={CheckImg} alt="Success" />}
            <p className="mt-3 text-xl font-semibold">{t("common.success")}</p>
            <span className="text-xs text-monochrome-300">
              {message.message}
            </span>
          </div>
        </div>
      </>
    );
  };

  const CaptureInstruction = () => {
    return (
      <div className="mt-2 flex gap-2 rounded-lg border border-monochrome-50 p-3 shadow-md">
        <div className="flex flex-col items-center">
          <ExclamationIcon />
          <div className="mt-2 w-px flex-grow bg-monochrome-300"></div>
        </div>
        <div className="flex flex-1 flex-col gap-2">
          <p className="text-2xs text-monochrome-300">
            {t("redeem.receiptVisibilityHint")}
          </p>
          <p className="text-2xs text-monochrome-300">
            {t("redeem.receiptFoldHint")}
          </p>
          <p className="text-2xs text-monochrome-300">
            <span className="text-blue-600">{t("common.clickHere")}</span>{" "}
            {t("redeem.viewReceiptExample")}
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>Redeem Voucher | Dompet Kartini</title>
      </Helmet>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
        loadingState={loadingState}
      />
      <ModalMechanism
        isOpen={isShowMechanism}
        redemptionMethod={redemptionMethod}
        setIsOpen={setIsShowMechanism}
        brands={detailVoucher.brands ?? null}
        sku={data.sku}
        mechanism={detailVoucher.mechanism}
      />
      {step === 4 && message.isShow && BannerMessage()}
      <Container>
        <div
          className={`space-y-5 px-5 ${(step === 2 && !projectSettings?.validation?.receipt?.isEnable) || (step === 3 && imageReceipt) ? "pb-32" : "pb-20"} pt-5`}
        >
          {step < 4 && (
            <div className="flex items-center justify-between">
              {step < 4 && (
                <button
                  className=""
                  onClick={() => {
                    if (step === 1) {
                      navigate("/", { replace: true });
                    } else if (step === 3 && imageReceipt) {
                      setStep(2);
                      setImageReceipt(null);
                    } else {
                      setStep(step - 1);
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
              <div className="flex items-center justify-center gap-2">
                <div
                  className={`px-1.5 ${
                    step >= 1
                      ? "gradient-bg text-white"
                      : "bg-gray-200 text-gray-500"
                  } flex h-7 w-7 items-center justify-center rounded-full text-sm font-medium`}
                  onClick={() => setStep(1)}
                >
                  1
                </div>

                {step === 1 ? (
                  <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                    Tukar Voucher
                  </p>
                ) : (
                  <p className="text-lg text-monochrome-400">&#9656;</p>
                )}
                <div
                  className={`px-1.5 ${
                    step >= 2
                      ? "gradient-bg text-white"
                      : "bg-gray-200 text-gray-500"
                  } flex h-7 w-7 items-center justify-center rounded-full text-sm font-medium`}
                >
                  2
                </div>
                {step === 2 ? (
                  <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                    {t("redeem.receiptPhoto")}
                  </p>
                ) : (
                  <p className="text-lg text-monochrome-400">&#9656;</p>
                )}
                <div
                  className={`px-1.5 ${
                    step === 3
                      ? "gradient-bg text-white"
                      : "bg-gray-200 text-gray-500"
                  } flex h-7 w-7 items-center justify-center rounded-full text-sm font-medium`}
                >
                  3
                </div>

                {step === 3 && (
                  <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                    Review
                  </p>
                )}
              </div>
            </div>
          )}
          <div>
            {step !== 3 &&
              step !== 2 &&
              step !== 4 &&
              (data?.voucher?.voucherImage ||
              detailVoucher.url ||
              detailVoucher.urlImage ||
              detailVoucher?.voucherImage ? (
                <img
                  className="h-48 w-full rounded-lg border border-monochrome-50 object-cover object-center shadow-md "
                  src={
                    data?.voucher?.voucherImage ??
                    detailVoucher?.url ??
                    detailVoucher?.urlImage ??
                    detailVoucher?.voucherImage ??
                    KartiniOnboard
                  }
                  alt="Kartini"
                />
              ) : (
                <div className="flex h-48 items-center justify-center bg-gray-100">
                  Voucher image not available
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="ml-2 h-6 w-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
                    />
                  </svg>
                </div>
              ))}
          </div>
          {/* Foto Struk */}
          {step === 2 && (
            <div className="max-h-dvh">
              {imageReceipt ? (
                <div className="mx-auto max-w-lg">
                  <img
                    src={imageReceipt}
                    alt="Imh"
                    className="h-auto w-full rounded-lg"
                  />
                </div>
              ) : (
                <>
                  <div className="group relative flex h-[20%] justify-center"></div>
                  <div className="px-0 md:px-[calc(32rem-5vw)]">
                    <Camera
                      ref={webcamRef}
                      aspectRatio={3 / 4}
                      numberOfCamerasCallback={setNumberOfCameras}
                      className="rounded-lg"
                      facingMode="environment"
                    />
                  </div>
                  {/* <Webcam
                  videoConstraints={{
                    width: { min: 480 },
                    height: { min: 720 },
                    aspectRatio: 0.6666666667,
                    facingMode: "environment",
                  }}
                  audio={false}
                  height={720}
                  screenshotQuality={1}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width={480}
                  className="rounded-lg"
                  onUserMedia={() => setNumberOfCameras(1)}
                  onUserMediaError={() => setNumberOfCameras(0)}
                  onCameraError={() => setNumberOfCameras(0)}
                /> */}
                  {numberOfCameras > 0 ? (
                    CaptureInstruction()
                  ) : (
                    <p className="text-center">No camera available</p>
                  )}
                </>
              )}
            </div>
          )}
          {/* Detail Voucher */}
          {step !== 2 && (
            <div className="grid grid-cols-6 items-start gap-4">
              {step === 3 && imageReceipt && (
                <div className="col-span-6 md:col-span-2">
                  <img
                    src={imageReceipt}
                    alt="Imh"
                    className="h-auto w-full rounded-lg"
                  />
                </div>
              )}
              {step === 1 && (
                <div className="col-span-6">
                  <CardSection title={t("redeem.promoMechanism")}>
                    <button
                      className="flex w-full items-center justify-between"
                      onClick={() => setIsShowMechanism(true)}
                    >
                      <p className="text-xs text-monochrome-400">
                        {t("redeem.clickForMechanismDetail")}
                      </p>
                      <ChevronIcon />
                    </button>
                  </CardSection>
                </div>
              )}
              {redemptionMethod === "MANUAL" &&
                step === 1 &&
                shouldShowPhoneNumber && (
                  <div className="col-span-6">
                    <CardSection title="Nomor Telepon Pengguna">
                      <div className="text-sm">
                        <div className="mt-1.5 flex h-12 items-stretch overflow-hidden rounded-md border border-gray-300 bg-white focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500">
                          <div className="flex items-center border-r border-gray-300 bg-gray-50 px-3 text-sm font-semibold text-gray-600">
                            +62
                          </div>
                          <input
                            name="phone"
                            placeholder="81234567890"
                            className={`form-input mb-0.5 h-full w-full border-0 font-semibold focus:ring-0 ${
                              shouldRequireValidPhone &&
                              phoneNumber &&
                              !isValidPhoneNumber(phoneNumber)
                                ? "border-2 border-red-500"
                                : ""
                            }`}
                            type="tel"
                            inputMode="numeric"
                            value={phoneNumber.replace(/^62/, "")}
                            onChange={(e) => {
                              const nextValue = normalizePhoneNumber(
                                e.target.value,
                              );
                              setPhoneNumber(nextValue);
                            }}
                          />
                        </div>
                        {shouldRequireValidPhone &&
                          phoneNumber &&
                          !isValidPhoneNumber(phoneNumber) && (
                          <p className="mt-2 text-xs text-red-500">
                            Format nomor telepon harus berisi 10-15 digit.
                          </p>
                        )}
                      </div>
                    </CardSection>
                  </div>
                )}
              {data.voucherMethod === "DYNAMIC" && step === 1 && (
                <div className="col-span-6">
                  <CardSection title="Nilai Pembelian">
                    <div className="text-sm">
                      <input
                        name="nominal"
                        placeholder="Masukkan nilai pembelian produk (Rp)"
                        className={`form-input mb-0.5 mt-1.5 h-12 w-full font-semibold ${
                          purchaseAmount > 0 &&
                          purchaseAmount < data.voucherRules?.minPurchase &&
                          "border-2 border-red-500"
                        }`}
                        type="text"
                        value={
                          purchaseAmount
                            ? formatRupiah(purchaseAmount?.toString(), "Rp. ")
                            : ""
                        }
                        onChange={(e) => {
                          let value =
                            e.target.value?.replace(/[^\d]/g, "") || "";
                          setPurchaseAmount(value);
                          calculate(parseInt(value));
                        }}
                      />
                      <div className="mt-2 flex items-center justify-between">
                        <div className="flex items-center space-x-1 text-xs font-medium text-gray-400">
                          <div>{t("redeem.discountAmount")} </div>
                        </div>
                        {isLoading ? (
                          <div class="h-3 w-24 animate-pulse rounded bg-gray-200"></div>
                        ) : (
                          <div>{formatRupiah(discount.toString(), "Rp. ")}</div>
                        )}
                      </div>
                      {purchaseAmount > 0 &&
                        purchaseAmount < data.voucherRules?.minPurchase && (
                          <p className="mt-2 text-xs text-red-500">
                            Minimum pembelian adalah{" "}
                            {formatRupiah(
                              data.voucherRules?.minPurchase.toString(),
                              "Rp. ",
                            )}
                          </p>
                        )}
                      {purchaseAmount > 0 &&
                        purchaseAmount > data.voucherRules?.maxPurchase && (
                          <p className="mt-2 text-xs text-red-500">
                            Maximum pembelian adalah{" "}
                            {formatRupiah(
                              data.voucherRules?.maxPurchase.toString(),
                              "Rp. ",
                            )}
                          </p>
                        )}
                    </div>
                  </CardSection>
                </div>
              )}
              <div
                className={
                  step === 3 && imageReceipt
                    ? "col-span-6 md:col-span-4"
                    : "col-span-6"
                }
              >
                <CardSection title={t("redeem.voucherDetail")}>
                  <div className="">
                    <div className="space-y-2">
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          {t("redeem.uvcType")}
                        </div>
                        <p className="col-span-3 text-right text-monochrome-600">
                          {data.voucherMethod === "DYNAMIC"
                            ? t("redeem.dynamic")
                            : t("redeem.static")}
                        </p>
                      </div>
                      <hr />
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          {t("redeem.voucherName")}
                        </div>
                        <p className="col-span-3 text-right text-monochrome-600">
                          {data?.voucher?.description ??
                            detailVoucher?.title ??
                            "-"}
                        </p>
                      </div>
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          {t("redeem.voucherPeriod")}
                        </div>
                        <p className="col-span-3 text-right text-monochrome-600">
                          {`${
                            data.startDate
                              ? moment(data.startDate).format("DD-MM-yyyy")
                              : "-"
                          } - ${
                            data.endDate
                              ? moment(data.endDate).format("DD-MM-yyyy")
                              : "-"
                          }`}
                        </p>
                      </div>
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          {t("redeem.voucherAmount")}
                        </div>
                        <p className="col-span-3 text-right text-monochrome-600">
                          {data.voucherMethod === "DYNAMIC"
                            ? `Rp. ${discount.toLocaleString("id-ID")}`
                            : _.isNumber(
                                  data.uvc?.amountValue ||
                                    detailVoucher.amountValue,
                                )
                              ? Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }).format(
                                  data.uvc?.amountValue ??
                                    detailVoucher.amountValue,
                                )
                              : data.uvc?.amountValue ??
                                detailVoucher.amountValue ??
                                "-"}
                        </p>
                      </div>
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          Voucher Code
                        </div>
                        <p className="col-span-3 text-right text-monochrome-600">
                          {redemptionMethod === "MANUAL" &&
                          !_.isEmpty(manualUvc)
                            ? manualUvc.map((item) => (
                                <>
                                  {item.uvc} <br />
                                </>
                              )) ?? "-"
                            : data?.uvc?.uvc ?? "-"}
                        </p>
                      </div>
                      <hr />
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          {t("redeem.companyName")}
                        </div>
                        <p className="col-span-3 text-right text-monochrome-600">
                          {data?.project?.client?.name ??
                            detailVoucher?.client?.name ??
                            detailVoucher?.clients[0]?.name ??
                            "-"}
                        </p>
                      </div>
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          {t("redeem.voucherName")}
                        </div>
                        <p className="col-span-3 text-right text-monochrome-600">
                          {data?.project?.alias}
                        </p>
                      </div>
                      <div className="grid grid-cols-5 text-xs">
                        <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                          {t("redeem.brandName")}
                        </div>
                        <p className="col-span-3 break-all text-right text-monochrome-600">
                          {detailVoucher?.sku?.brand?.name ??
                            (_.isArray(detailVoucher.brands)
                              ? [
                                  ...new Set(
                                    detailVoucher.brands.map(
                                      (brand) => brand.name,
                                    ),
                                  ),
                                ].join(", ")
                              : "-")}
                        </p>
                      </div>
                      {!_.isEmpty(data.skuSelected) && (
                        <div className="grid grid-cols-5 text-xs">
                          <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                            {t("redeem.skuName")}
                          </div>

                          <p className="col-span-3 text-right text-monochrome-600">
                            {data.skuSelected.map((sku) => sku.name).toString()}
                          </p>
                        </div>
                      )}
                      {redemptionMethod !== "MANUAL" && (
                        <div className="grid grid-cols-5 text-xs">
                          <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                            {t("redeem.skuName")}
                          </div>
                          <p className="col-span-3 text-right text-monochrome-600">
                            {detailVoucher?.sku?.name ??
                              (_.isArray(data.sku)
                                ? data.sku.map((sku) => sku?.name).toString()
                                : "-")}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardSection>
              </div>
            </div>
          )}
        </div>
      </Container>
      <div className="fixed bottom-0 w-full bg-white">
        <div className="mx-auto flex max-w-screen-xl flex-col space-y-2 px-4 py-2 md:flex-row md:justify-end md:gap-2 md:space-y-0">
          {step === 3 && imageReceipt && (
            <Button
              variant="default"
              label={t("redeem.retakePhoto")}
              onClick={() => {
                setImageReceipt(null);
                setStep(2);
              }}
            />
          )}
          <Button
            variant={step !== 4 ? "gradient" : "default"}
            label={
              step === 1
                ? t("redeem.confirmVoucherRedemption")
                : step === 2
                  ? _.isEmpty(imageReceipt)
                    ? t("redeem.receiptPhoto")
                    : t("redeem.retakePhoto")
                  : step === 3
                    ? t("common.confirm")
                    : step === 4 && t("common.back")
            }
            onClick={async () => {
              if (step === 3) {
                VoucherRedeem();
              } else if (step === 2 && numberOfCameras > 0) {
                if (_.isEmpty(imageReceipt)) {
                  capture();
                } else {
                  setImageReceipt(null);
                }
              } else if (step === 4) {
                navigate("/", { replace: true });
              } else if (step === 1 && shouldCheckCustomerLimit) {
                setIsCheckingCustomerLimit(true);
                setShowModalLoading(true);
                try {
                  const bookVoucher = getBookVoucherCount(multipleSkuId);
                  for (const { id: sku } of multipleSkuId ?? []) {
                    const limitCheck = await checkVoucherLimit({
                      project: data?.project?.id,
                      retailer: data?.retailer?.id,
                      voucher: detailVoucher.id,
                      sku,
                      phone: phoneNumber,
                      bookVoucher,
                    });

                    if (limitCheck.error) {
                      toastNotify(
                        limitCheck.detailMessage ||
                          limitCheck.data?.data?.message ||
                          "Tidak dapat memeriksa batas penukaran. Silakan coba lagi.",
                        "error",
                      );
                      return;
                    }

                    if (!limitCheck.data?.data?.allowed) {
                      toastNotify(
                        "Nomor telepon ini telah mencapai batas penukaran voucher.",
                        "error",
                      );
                      return;
                    }
                  }
                  setStep(step + 1);
                } catch (error) {
                  if (!error?.message) {
                    toastNotify(
                      "Tidak dapat memeriksa batas penukaran. Silakan coba lagi.",
                      "error",
                    );
                  }
                } finally {
                  setIsCheckingCustomerLimit(false);
                  setShowModalLoading(false);
                }
              } else {
                setStep(step + 1);
              }
            }}
            disabled={
              (step === 3 &&
                _.isEmpty(imageReceipt) &&
                projectSettings?.validation?.receipt?.isEnable) ||
              (step === 1 &&
                data.voucherMethod === "DYNAMIC" &&
                (purchaseAmount === "" || discount <= 0)) ||
              (shouldRequireValidPhone && !isValidPhoneNumber(phoneNumber)) ||
              isCheckingCustomerLimit ||
              (step === 2 && (numberOfCameras === 0 || showModalLoading))
            }
          />

          {step === 2 && !projectSettings?.validation?.receipt?.isEnable && (
            <Button
              variant="default"
              label={t("common.skip")}
              onClick={() => setStep(3)}
            />
          )}
        </div>
      </div>
      {/* Information Sheet */}
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
      {/* </>
      )} */}
    </>
  );
};

export default withAuth(ConfirmVoucher);
